import { Component, OnInit } from '@angular/core';
import { InfoListOcurrenceComponent } from '../info-list-ocurrence/info-list-ocurrence.component';
import { MainContainerService } from '../main-container/main-container.service';
import { Util } from '../shared/util.service';
import { PopupConfigService } from '../popup-config/popup-config.service';
import { UsuarioOcorrencia } from '../popup-config/model/usuarioOcorrencia.model';
import { PopupOcorrenciaService } from '../popup-ocorrencia/popup-ocorrencia.service';

declare var jquery: any;
declare var $: any;

@Component({
  standalone: false,
  selector: 'main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.css']
})
export class MainContainerComponent implements OnInit {

  public btFiltro: Boolean;
  private filtroPor: string;
  public filtro: boolean = false;
  public totalRoteiros: number = 0;
  public search = false;
  public busca: string;
  public carregandoInfo: boolean = false;
  loadingBtnBusca = false
  mostraMotoristas = false; 
  mostraUsuarios = false;
  mostrarMenu = true


  filtroPorTipo = [
    {tipo: 'roteiro', descricao: 'Roteiro'},
    {tipo: 'pedido', descricao: 'Pedido'},
    {tipo: 'cliente', descricao: 'Cliente'},
    {tipo: 'motorista', descricao: 'Motorista'}
  ]


  constructor(
    public mainContainerService: MainContainerService,
    public popupConfigService: PopupConfigService,
    private popupOcorrenciaService: PopupOcorrenciaService,
    public util: Util,
  ) { }



  async ngOnInit() {
    this.carregandoInfo = false;

    this.btFiltro = false;
    this.filtroPor = 'roteiro';
    this.mainContainerService.ocorrenciaSelecionado = [];

    await this.carregaOcorrencias()
    await this.carregaRoteiros();
    this.habilitaShowRoteiro()
    this.contadorTotalRoteiro();

    this.consultaRoteiroAlerta()    
    await this.consultaRoteiroRadarBusca() 

    this.carregandoInfo = true;   
  }

  async visualizarOcorrenciasDoRoteiro(roteiro) {
    $('#roteiro-selecionado').addClass('ativado');
    setTimeout(() => {
      $('#roteiro-selecionado').removeClass('ativado');
    }, 10);
    await this.mainContainerService.getVisualizarOcorrenciasDoRoteiro(roteiro);
  }

  async carregaOcorrencias() {
    await this.mainContainerService.getCarregaOcorrencias()
  }


  async carregaRoteiros() {
    let response = await this.mainContainerService.getCarregaRoteiros();
  }

  // --------------- RECARREGA DADOS-----------------//
  async recarregaDados() {
    this.carregandoInfo = false;
    await this.carregaOcorrencias();
    this.contadorTotalRoteiro();
    await this.carregaRoteiros();
    this.habilitaShowRoteiro()
    this.popupConfigService.filtraRoteirosTela()
    this.contadorTotalRoteiro();
    this.carregandoInfo = true;
  }

  LimpaSearch() {
  }

  resetfeedback() {
    this.filtro = false;
    this.search = false;
  }

  tipoFiltro(parametro) {
    this.filtroPor = parametro;
  }

  async filtroRoteiro(e, atualizaGrid = true, buscaOcRadar = false) {
    this.loadingBtnBusca = true;
    if (buscaOcRadar || e.keyCode === undefined || e.keyCode === 13) {
      {
        this.filtro = true;
        this.carregandoInfo = false;

      }
      if (this.filtroPor == 'roteiro' && this.busca == '') {
        this.filtro = false;
        this.carregandoInfo = false;


      }

      if(this.filtroPor != 'motorista'){
        this.mainContainerService.listaRoteiros = [];
        this.mainContainerService.listOcorrenciasRoteiroStatus = [];
      }

      switch (this.filtroPor) {
        case 'roteiro':

          const val1 = this.busca.substring(2, 3);
          const val2 = this.busca.substring(5, 6);

          if (String(val1) === '/' && String(val2) === '/') {
            let data: any = this.busca.split('/');
            data = data[2] + '-' + data[1] + '-' + data[0];
            await this.mainContainerService.getCarregaRoteirosData(data);
            this.carregandoInfo = true;

          }
          else {
            await this.mainContainerService.getCarregaRoteirosId(this.busca);
            this.carregandoInfo = true;
          }
          break;
        case 'pedido':
          await this.mainContainerService.getCarregaRoteirosPedido(this.busca);
          this.carregandoInfo = true;
          ;
          break;
        case 'cliente':
          await this.mainContainerService.getCarregaRoteirosCliente(this.busca);
          this.carregandoInfo = true;
          ;
          break;
        case 'motorista':
            this.habilitaShowRoteiro()
            this.filtroNomeMotorista(this.busca)
            this.carregandoInfo = true;
            break;
      }

      if (this.filtro) {
        this.totalRoteiros = this.mainContainerService.listaRoteiros.length;
        this.totalRoteiros == 0 ? this.search = true : this.search = false;
      }
      else {
        this.contadorTotalRoteiro();
      }
    }


    if(this.filtroPor != 'motorista' && atualizaGrid){
      this.habilitaShowRoteiro()
    }
    this.loadingBtnBusca = false;
  }

  async limparFiltro() {
    this.busca = '';
    this.mainContainerService.listaRoteiros = [];
    this.mainContainerService.listOcorrenciasRoteiroStatus = [];
    this.carregandoInfo = true;
    this.resetfeedback();
    this.recarregaDados();
  }

  contadorTotalRoteiro() {


    this.totalRoteiros = 0;

    for (let i = 0; i < this.mainContainerService.listaRoteiros.length; i++) {
      let item = this.mainContainerService.listaRoteiros[i];

      if (item.qtdOcorrenciasPorStatus.novo.length > 0 || item.qtdOcorrenciasPorStatus.analise.length > 0) {
        this.totalRoteiros++;
      }
    }
  }

  async atualizaListaOcorrencias(){    
    this.mainContainerService.loadingProcessando = true
    await this.mainContainerService.getCarregaRoteirosId(this.mainContainerService.listOcorrenciasRoteiroStatus[0].roteiro);
    await this.visualizarOcorrenciasDoRoteiro(this.mainContainerService.listOcorrenciasRoteiroStatus[0].roteiro)
    document.getElementById('bt-filtro').click()
    this.mainContainerService.loadingProcessando = false;
  }


 alteraShowMotorista(){
  this.mostraMotoristas = !this.mostraMotoristas;
  this.mostraUsuarios = false
 }

 alteraShowUsuario(){
  this.mostraUsuarios = !this.mostraUsuarios;
  this.mostraMotoristas = false;
 }

 atualizaUsuariosFiltrados(usuario){
  this.habilitaShowRoteiro()
  let usuarioFind: UsuarioOcorrencia = this.popupConfigService.usuariosOcorrencia.find((user) => usuario.UsuariosMotOcID == user.UsuariosMotOcID)
  usuarioFind.checked = !usuarioFind.checked;

  this.popupConfigService.atualizaDescUsuariosSel();
  this.popupConfigService.atualizaMotoristasChecked();

  }

  habilitaShowRoteiro(){
    this.mainContainerService.listaRoteiros = this.mainContainerService.listaRoteiros.map(
      (roteiro) => {
        roteiro.mostraRoteiro = true
        return roteiro
      });
  }

  filtroNomeMotorista(nomeMotorista: string){
    this.mainContainerService.listaRoteiros.forEach((motor) => {
      let buscaValor = motor.nome_motorista.toLowerCase().includes(nomeMotorista.toLowerCase());
      console.log(buscaValor)
      motor.mostraRoteiro = buscaValor;
    })
  }
  encontraOcorrencia(ocorrenciaID: number) {
    const listOcorrenciasPorStatus = this.mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus;
    let ocrrenciaEncontrada = null;
    for (const statusOcorrencia in listOcorrenciasPorStatus) {
        const lista = listOcorrenciasPorStatus[statusOcorrencia];
        for (const item of lista) {
            if (item.IdOcorrencia === ocorrenciaID) {
                ocrrenciaEncontrada = item;
                break;
            }
        }
        if (ocrrenciaEncontrada !== null) {
            break;
        }
    }
    return ocrrenciaEncontrada;
  } 

  async consultaRoteiroAlerta(){
    if(this.popupOcorrenciaService.roteiroAlertaId){

      let url = window.location.href;
      if (url.includes('&opc5=')) {
           url = url.replace(/&opc5=[^&]*/, ''); 
        window.history.replaceState({}, document.title, url);
      }
      
      this.carregandoInfo = true;
      let response = await this.mainContainerService.getAlertaId(this.popupOcorrenciaService.roteiroAlertaId);
      await this.visualizarOcorrenciasDoRoteiro(response[0].NumeroRoteiro)

      if(response[0].OcorrenciaID == null){
        this.popupOcorrenciaService.updateRoteiroAlerta = true;
        setTimeout(() => {        
        document.getElementById('btnCriarNova').click()
       }, 100);       
      }
      else{
        let objOcorrencia = this.encontraOcorrencia(response[0].OcorrenciaID);
        this.popupConfigService.objOcorrencia = objOcorrencia;
        this.popupOcorrenciaService.updateRoteiroAlerta = false;
        setTimeout(() => {
          document.getElementById('btnConsultarOcorrencia').click();
        }, 100);     

      }
      this.carregandoInfo = false;

    }
  }

  async consultaRoteiroRadarBusca(){
    if(this.popupOcorrenciaService.ocRoteiroBusca){      
      this.busca = this.popupOcorrenciaService.ocRoteiroBusca.roteiro.toString();
      await this.filtroRoteiro(null, true, true);
      await this.visualizarOcorrenciasDoRoteiro(this.busca);
      
      if(this.popupOcorrenciaService.ocRoteiroBusca.codigoOcorrencia){
        setTimeout(() => {
          document.getElementById('btnAbreOcRoteiroBuscaRadar').click()
        }, 100);
      }

      let url = window.location.href;
      if (url.includes('&opc6=')) {
        url = url.replace(/&opc6=[^&]*/, ''); 
        window.history.replaceState({}, document.title, url);
      }
    }
  }

  esconderMostrarMenu(){
    this.mostrarMenu = !this.mostrarMenu;
  }
}
